import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { Providers } from './context/Providers';
import DevErrorBoundary from './components/dev/DevErrorBoundary';

const app = React.createElement(Providers, null, React.createElement(App));
const tree = import.meta.env.DEV ? React.createElement(DevErrorBoundary, null, app) : app;

ReactDOM.createRoot(document.getElementById('root')!).render(tree);
